<template>
  <v-sheet
    color="transparent"
    :style="`background-image: url(${
      files + config.img_bg + '?resize=1&w=1920'
    });`"
    class="home-view"
  >
    <div
      class="
        home-view-content
        d-flex
        align-center
        flex-column
        justify-space-between
      "
    >
      <v-container fluid>
        <div v-if="config.img_logo" class="d-flex justify-center">
          <img
            class="home-view-content-logo"
            :src="files + config.img_logo"
            :alt="config.title"
          />
        </div>
        <div
          v-if="config.title"
          class="
            text-center text-h6 text-sm-h5 text-md-h4
            font-weight-medium
            pb-10
            pt-4
          "
          :class="config.body_color ? 'custom-body-text--color' : 'white--text'"
        >
          <span class="font-lufga">
            {{ config.title }}
          </span>
        </div>
        <div
          v-if="config.description"
          class="d-flex justify-center py-2"
          :class="config.body_color ? 'custom-body-text--color' : 'white--text'"
        >
          <span class="text-center font-lufga">{{ config.description }}</span>
        </div>
        <div v-if="social && social.length" class="d-flex justify-center py-5">
          <v-btn
            v-for="({ icon, link, size }, socialKey) in social"
            :key="socialKey"
            :href="link"
            fab
            height="45px"
            width="45px"
            depressed
            class="mx-2"
            color="custom-btn-bg--color-alt"
            target="_blank"
          >
            <v-icon
              :color="config.btn_bg_color ? 'custom-icon' : 'white'"
              :size="size"
              >{{ icon }}</v-icon
            >
          </v-btn>
        </div>
        <v-row justify="center">
          <LoadingWidget v-if="loading" />
          <transition name="fade">
            <v-col
              v-if="!loading"
              cols="12"
              md="9"
              lg="7"
              class="d-flex flex-column home-view-content-links"
            >
              <template v-for="({ title, links }, categoriesKey) in links">
                <div :key="categoriesKey" :class="title ? 'pb-5' : ''">
                  <div
                    v-if="title"
                    class="
                      d-flex
                      justify-center
                      font-weight-bold
                      text-h6 text-uppercase
                      pt-5
                    "
                    :class="
                      config.body_color
                        ? 'custom-body-text--color'
                        : 'white--text'
                    "
                  >
                    <span class="font-lufga">
                      {{ title }}
                    </span>
                  </div>
                  <div
                    class="py-2"
                    :key="linksKey"
                    v-for="(item, linksKey) in links"
                  >
                    <ButtonsPill v-bind="item" :config="config"></ButtonsPill>
                  </div>
                </div>
              </template>
            </v-col>
          </transition>
        </v-row>
      </v-container>
      <v-container v-if="config.address">
        <v-row justify="center">
          <v-col cols="12" md="9" lg="7" class="d-flex justify-center">
            <a
              v-ripple
              class="
                text-decoration-none
                font-weight-medium
                text-body-2
                pa-2
                d-flex
                justify-center
                align-center
                rounded
              "
              :class="
                config.body_color ? 'custom-body-text--color' : 'white--text'
              "
              :href="config.google_maps"
              target="_blank"
            >
              <v-icon
                :color="config.body_color ? 'custom-icon-color-alt' : 'white'"
                class="mr-2"
                >fas fa-map-marker-alt</v-icon
              >
              <span class="">{{ config.address }}</span>
            </a>
          </v-col>
        </v-row>
      </v-container>
      <div
        v-if="config.text_footer"
        class="home-view-content-footer text-center"
        :class="config.body_color ? 'custom-body-text--color' : 'white--text'"
      >
        <span class=""> {{ config.text_footer }}</span>
      </div>
    </div>
  </v-sheet>
</template>

<script>
import ButtonsPill from "../components/pills/ButtonsPill.vue";
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import { getSocial } from "../utils/getSocial";

const _config = {
  mod: "links",
};

export default {
  data: () => ({
    loading: false,
    categories: [],
    links: [],
  }),
  computed: {
    config() {
      return this.$rest("config").item;
    },
    social() {
      return getSocial(this.config);
    },
  },
  methods: {
    getLinksByCategory(category) {
      const params = {
        category: category.id,
      };
      return this.$rest(_config.mod)
        .get({ params })
        .then((data) => {
          if (data && data.length)
            this.links.push({
              title: category.title,
              links: data.map(({ id, target, icon, link, title }) => ({
                id,
                target,
                icon,
                link,
                title,
              })),
            });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getLinksWithoutCategory() {
      this.$rest(_config.mod)
        .get()
        .then((data) => {
          data
            .filter((item) => !item.category)
            .forEach((item) => {
              this.links.push({
                title: null,
                links: [
                  {
                    id: item.id,
                    target: item.target,
                    icon: item.icon,
                    link: item.link,
                    title: item.title,
                  },
                ],
              });
            });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getAllLinks() {
      this.loading = true;
      this.getCategories()
        .then(() => {
          this.getLinksWithoutCategory();
        })
        .then(() => {
          const promises = this.categories.map((category) =>
            this.getLinksByCategory(category)
          );
          return Promise.all(promises);
        })
        .finally(() => {
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        });
    },
    getCategories() {
      return this.$rest("categories")
        .get()
        .then((data) => {
          this.categories = data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  created() {
    this.getAllLinks();
  },

  components: { ButtonsPill, LoadingWidget },
};
</script>

<style lang="scss">
.btn-outlined {
  position: relative;
  transition: all 0.15s ease;
  &:hover {
    background-color: var(--custom-btn-text-color) !important;
    span,
    i {
      color: white !important;
      transition: all 0.15s ease;
    }
  }
  &::before {
    content: "";
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    position: absolute;
    opacity: 0.4;
    border: 1px solid var(--custom-btn-text-color);
    border-radius: 36px;
  }
}
.home-view {
  min-height: 100vh;
  height: 100%;
  background-size: cover;
  background-position: center;
  &-content {
    padding: 80px 0 80px 0;
    min-height: 100vh;
    height: 100%;
    width: 100%;
    &-logo {
      width: 400px;
      height: 136px;
      object-fit: contain;
      @media (max-width: 600px) {
        width: 100%;
        padding: 0 20px 0 20px;
      }
    }
    // &-links {
    //   gap: 30px;
    // }
    &-footer {
      position: absolute;
      bottom: 0;
    }
  }
}
</style>
